import { apiGet, apiPut } from '../client';
import {
  BusinessMeResponseSchema,
  BusinessPermissionsResponseSchema,
  type AccessProfile,
  type BusinessMeResponse,
  type BusinessPermissionsResponse,
  type PermissionKey,
} from '../schemas';

export const PERMISSIONS_QUERY_KEY = ['business-permissions'];
export const ME_QUERY_KEY = ['business-me'];

/** What each profile may use in this location. Owner-only. */
export function getPermissions(): Promise<BusinessPermissionsResponse> {
  return apiGet('/v1/business/permissions', BusinessPermissionsResponseSchema);
}

/**
 * Replaces one profile's whole list; the API refuses the write without an Idempotency-Key.
 * `expectedVersion` is that profile's version as the screen read it (0 when it had no stored row);
 * a stale one comes back 409 version_conflict with all the profiles as `GET` reads them.
 */
export function savePermissions(
  profile: AccessProfile,
  permissions: readonly PermissionKey[],
  idempotencyKey: string,
  options: { expectedVersion?: number } = {},
): Promise<BusinessPermissionsResponse> {
  return apiPut(
    `/v1/business/permissions/${encodeURIComponent(profile)}`,
    BusinessPermissionsResponseSchema,
    { permissions, ...(options.expectedVersion !== undefined ? { expectedVersion: options.expectedVersion } : {}) },
    idempotencyKey,
  );
}

/** Who is signed in and what they may use right now; any business session. */
export function getMe(): Promise<BusinessMeResponse> {
  return apiGet('/v1/business/me', BusinessMeResponseSchema);
}
